(function() {
    /* globals angular */

    angular.module('ngmvac').filter('forName', ForName);

    function ForName() {

        return function(arr, name) {

            if (name != "") {
                var hotelArray = [];
                var arrAux = [];
                angular.forEach(arr, function(hotel) {
                    hotelArray.push(hotel);
                });
                var nombre = "";
                for (var i = 0; i < hotelArray.length; i++) {
                    nombre = hotelArray[i].name;
                    if (nombre.toLowerCase().indexOf(name.toLowerCase()) != -1) {
                        arrAux.push(hotelArray[i]);
                    }
                }
            } else {
                arrAux = arr;
            }

            return arrAux;

        }
    }
})();
